import { APIfetch } from "../../APIRoot";
import APILink from "../../components/APILink";
import { fullQueryString, routeRest } from "../../utils";
import React from "react";

import { pushTrackEventPageName } from "../../helpers/Adobe.analytics";
import { useKeycloakContext } from "../../contexts/AuthContext";
import { useLocation } from "react-router-dom";

export const createAPICall =
  (queryObject, updateStateWhenCallingAPI, patientView) => async () => {
    const { pageInfo, lightAdmissionTOs } = await APIfetch(
      "admissions",
      fullQueryString(queryObject)
    );

    let medicard;
    if (patientView && lightAdmissionTOs.length === 0) {
      medicard = await APIfetch(`medicards/${queryObject.medicardNumber}`);
    }

    if (updateStateWhenCallingAPI) {
      pushTrackEventPageName("hospiadmission/admissions/searchresults");
      updateStateWhenCallingAPI();
    }

    return {
      pageInfo,
      lightAdmissionTOs,
      medicard,
    };
  };

export const HistoryButton = ({
  queryObject,
  children,
  style,
  disabled,
  patientView,
  pathname = "admissions",
  updateStateWhenCallingAPI,
}) => {
  const { initialized, ...keycloak } = useKeycloakContext();

  return (
    initialized &&
    keycloak.authenticated && (
      <APILink
        to={{
          pathname,
          search: fullQueryString(queryObject),
        }}
        disabled={disabled}
        APICall={createAPICall(
          queryObject,
          updateStateWhenCallingAPI,
          patientView
        )}
        style={style}
      >
        {children}
      </APILink>
    )
  );
};

const createDetailsAPICall =
  (hospitalId, admissionNumber, currentState, openModal) => async () => {
    const admissionDetails = await APIfetch(
      `hospitals/${hospitalId}/admissions/${admissionNumber}`
    );
    pushTrackEventPageName("hospiadmission/admissions/details");
    openModal();
    return { ...currentState, admissionDetailsForModal: admissionDetails };
  };

export const DetailsButton = ({
  admissionNumber,
  currentState,
  openModal,
  children,
  style,
  disabled,
  hospitalId,
}) => {
  const { initialized, ...keycloak } = useKeycloakContext();
  const location = useLocation();
  return (
    initialized &&
    keycloak.authenticated && (
      <APILink
        to={{
          pathname: routeRest(location.pathname),
          search: location.search,
        }}
        disabled={disabled}
        APICall={createDetailsAPICall(
          hospitalId,
          admissionNumber,
          location.state,
          openModal
        )}
        style={style}
      >
        {children}
      </APILink>
    )
  );
};
